"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _theme = require("../../theme");

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var handleSize = function handleSize(size) {
  var sizeObj;

  switch (size) {
    case "small":
      sizeObj = {
        padding: "6px 12px",
        fontSize: "12px"
      };
      return sizeObj;

    case "large":
      sizeObj = {
        padding: "10px 20px",
        fontSize: "18px"
      };
      return sizeObj;

    default:
      sizeObj = {
        padding: "8px 16px",
        fontSize: "16px"
      };
      return sizeObj;
  }
};

var Wrapper = _styledComponents.default.button(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  position: relative;\n  cursor: pointer;\n  overflow: hidden;\n  min-height: 40px;\n  min-width: 120px;\n  transition: all 500ms ease-in-out;\n  outline: none;\n  border: none;\n  background-color: transparent;\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  font-weight: ", ";\n  flex-direction: ", ";\n  justify-content: ", ";\n\n  & span {\n    position: relative;\n    z-index: 1;\n  }\n\n  & svg {\n    width: 20px;\n    height: 20px;\n    fill: ", ";\n    transition: all 500ms ease-in-out;\n    position: relative;\n    z-index: 1;\n    transform: ", ";\n  }\n\n  & svg:nth-of-type(1) {\n    margin: 0 0.5rem;\n  }\n\n  & svg:nth-of-type(2) {\n    position: absolute;\n    width: 20px;\n    left: -20px;\n  }\n\n  &:before,\n  :after {\n    display: block;\n    content: \"\";\n    height: 100%;\n    position: absolute;\n    transform: translateY(-50%);\n    top: 50%;\n    left: 0;\n    transition: all 500ms ease-out;\n    z-index: 0;\n  }\n\n  &:before {\n    width: 0;\n    background-color: ", ";\n  }\n\n  &:after {\n    width: 50%;\n    background-color: ", ";\n  }\n\n  &:hover {\n    color: ", ";\n  }\n\n  &:hover svg:nth-of-type(1) {\n    opacity: 0;\n  }\n\n  &:hover svg:nth-of-type(2) {\n    left: calc(50% - 20px);\n    transition: all 500ms ease-out;\n  }\n\n  &:hover:before,\n  :hover:after {\n    width: 100%;\n    left: 100%;\n    opacity: 0;\n    transition: all 500ms ease-out;\n  }\n"])), function (_ref) {
  var width = _ref.width;
  return "".concat(width, "px");
}, function (_ref2) {
  var height = _ref2.height;
  return "".concat(height, "px");
}, function (_ref3) {
  var fontColor = _ref3.fontColor;
  return fontColor;
}, function (_ref4) {
  var fontWeight = _ref4.fontWeight;
  return fontWeight;
}, function (_ref5) {
  var iconPosition = _ref5.iconPosition;
  return iconPosition === "left" ? "row-reverse" : "row";
}, function (_ref6) {
  var iconPosition = _ref6.iconPosition;
  return iconPosition === "left" ? "flex-end" : "flex-start";
}, function (_ref7) {
  var iconFill = _ref7.iconFill;
  return iconFill;
}, function (_ref8) {
  var iconPosition = _ref8.iconPosition;
  return iconPosition === "left" ? "scale(-1,1)" : "scale(1,1)";
}, function (_ref9) {
  var backgroundColorTwo = _ref9.backgroundColorTwo;
  return backgroundColorTwo;
}, function (_ref10) {
  var backgroundColorOne = _ref10.backgroundColorOne;
  return backgroundColorOne;
}, function (_ref11) {
  var hoverFontColor = _ref11.hoverFontColor;
  return hoverFontColor;
});

var _default = Wrapper;
exports.default = _default;